export const defaultState = () => ({
	step          : 0,
	forward       : true,
	complete      : false,
	extraFeatures : [
		'google-analytics',
		'social-proof',
	],
})

const state = defaultState()

export default state
